import { useMemo } from "preact/hooks";
import Icons from "@components/icons.ts";
import { ComboboxButtonMultiSelect } from "@components/ComboBoxes/ComboboxButtonMultiSelect";
import type { Specialties } from "@services/filter-api/types";

interface NeedsFilterButtonProps {
  breakpoint?: string;
  centeredFilters?: boolean;
  filter_buttons_props?: Array<{
    name: string;
    label: string;
    is_optional: boolean;
    is_multi_select: boolean;
    placeholder: string;
  }>;
  handleGetSelectedItems: (items: any[]) => void;
  handleOpenClick: (open: boolean) => void;
  handleSelectLater: any;
  isMobile?: boolean;
  open: boolean;
  optional?: boolean;
  rebrand?: boolean;
  selectLater: any;
  selectedItems: any;
  specialties: Specialties;
  tabbedFilters?: boolean;
}

export const NeedsFilterButton = ({
  breakpoint,
  centeredFilters,
  filter_buttons_props,
  handleGetSelectedItems,
  handleOpenClick,
  handleSelectLater,
  isMobile,
  open,
  optional,
  rebrand,
  selectedItems,
  selectLater,
  specialties,
  tabbedFilters,
}: NeedsFilterButtonProps) => {
  const placeholder = useMemo(() => {
    return filter_buttons_props?.[2]?.placeholder || "Select your needs";
  }, [filter_buttons_props]);

  const label = useMemo(() => {
    const buttonProp = filter_buttons_props?.[2];
    if (buttonProp) {
      return `${buttonProp.label}${buttonProp.is_optional ? "" : "*"}`;
    }
    return "needs";
  }, [filter_buttons_props]);

  const endIcon = useMemo(() => {
    return <Icons.CaretDownIcon open={open} />;
  }, [open]);

  const shouldRender = useMemo(() => {
    return filter_buttons_props?.find(prop => prop.name === 'needs');
  }, [filter_buttons_props]);

  if (!shouldRender) {
    return null;
  }

  return (
    <ComboboxButtonMultiSelect
      breakpoint={breakpoint}
      buttonWrapperClass="border-gt-black w-11/12 md:border-t border-b md:border-r my-2 md:my-0"
      centeredFilters={centeredFilters}
      endIcon={endIcon}
      handleGetSelectedItems={handleGetSelectedItems}
      handleOpenClick={handleOpenClick}
      handleSelectLater={handleSelectLater}
      isMobile={isMobile}
      label={label}
      name="Specialties"
      open={open}
      optional={optional}
      placeholder={placeholder}
      rebrand={rebrand}
      selectLater={selectLater}
      selectedItems={selectedItems}
      specialties={specialties}
      tabbedFilters={tabbedFilters}
    />
  );
};
